import React from 'react';
import moment from 'moment';
import t from 'react-translate';

import { TimelineSurvey } from 'redux/schemas/models/survey';

import NvIcon from 'shared/components/nv-icon';
import { CheckIcon, todoIcon, todoProgress } from './todo-row';
import TodoThumbnail, { TodoThumbnailProps } from './todo-thumbnail';
import ActivityDeadline from './activity-deadline';

type SurveyTodoProps = TimelineSurvey & TodoThumbnailProps;

function SurveyTodo({
  type,
  title,
  progress,
  expirationDate,
  thumbnailSrc,
  backgroundColor,
}: SurveyTodoProps) {
  const icon = todoIcon[type];
  const deadlineMoment = moment(expirationDate);
  const currentMoment = moment();

  const isMissed = progress === todoProgress.MISSED;
  const isComplete = progress === todoProgress.COMPLETED;

  const showDueSoon = !isComplete
    && deadlineMoment > currentMoment
    && deadlineMoment < moment().add(7, 'days');

  const todoClassNames = [
    'todo-container',
    showDueSoon && 'due-soon',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={todoClassNames}>
      <div className='todo-description'>
        <TodoThumbnail
          thumbnailSrc={thumbnailSrc}
          backgroundColor={backgroundColor}
        />
        <div className='todo-icon'>
          {isComplete
            ? <CheckIcon />
            : <NvIcon icon={icon} size='smallest' />}
        </div>
        <div className='todo-title'>
          {title}
        </div>
      </div>
      <div className='todo-content'>
        <div className='status'>
          {isComplete && t.TIMELINE.EXERCISE_STATUS.SUBMITTED()}
          {isMissed && t.TIMELINE.EXERCISE_STATUS.MISSED()}
        </div>
        <ActivityDeadline deadline={expirationDate} />
      </div>
    </div>
  );
}

export default SurveyTodo;
